export { LoadingDots, type LoadingDotsProps } from './LoadingDots';
export {
  loadingDotVariants,
  type LoadingDotVariantProps,
} from './loading-dots.variants';
